/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { MenuBarLink } from "~/layout/MenuBar/MenuItem";
import { Submenu } from "~/layout/MenuBar/Submenu";
import { ROUTES } from "~/routing/routes";

export function SettingsSubmenu() {
  return (
    <Submenu>
      <>
        <ul>
          <li>
            <MenuBarLink route={ROUTES.notificationGroups.index}>
              Notification Groups
            </MenuBarLink>
          </li>
          <li>
            <MenuBarLink route={ROUTES.mappingRules.index}>
              Mapping Rules
            </MenuBarLink>
          </li>
        </ul>
      </>
    </Submenu>
  );
}
